import { MultiSelect } from "@mantine/core";
import type { User } from "../shared/types";

export const assigneeName = (person: User) =>
  person.github_login ? `@${person.github_login}` : person.name;

export default function AssigneePicker({
  members,
  selected,
  current = [],
  onChange,
  disabled = false,
  label = "负责人",
}: {
  members: User[];
  selected: string[];
  current?: User[];
  onChange: (ids: string[]) => void;
  disabled?: boolean;
  label?: string;
}) {
  const options = [
    ...new Map(
      [...members, ...current].map((person) => [person.id, person]),
    ).values(),
  ];
  return (
    <MultiSelect
      className="ui-assignees"
      label={`${label}（可多选）`}
      placeholder={selected.length ? "继续添加…" : "搜索并选择成员"}
      data={options.map((person) => ({
        value: person.id,
        label: assigneeName(person),
      }))}
      value={selected}
      onChange={onChange}
      disabled={disabled}
      searchable
      clearable
      maxValues={10}
      maxDropdownHeight={220}
      nothingFoundMessage={
        options.length ? "没有匹配的成员" : "暂无可选成员，请先同步团队"
      }
      clearButtonProps={{
        "aria-label": `清空${label}`,
        "aria-hidden": false,
        tabIndex: 0,
      }}
      comboboxProps={{ withinPortal: false }}
      renderOption={({ option }) => {
        const person = options.find((item) => item.id === option.value)!;
        return (
          <div className="ui-member-option">
            <span>{option.label}</span>
            {person.github_login && person.name !== person.github_login ? (
              <small>{person.name}</small>
            ) : null}
            {!members.some((member) => member.id === person.id) ? (
              <small>GitHub 当前已指派</small>
            ) : null}
          </div>
        );
      }}
    />
  );
}
